"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _lodash = _interopRequireDefault(require("lodash.get")),
    _Notifications = require("../../Notifications"),
    _silencedErrors = _interopRequireWildcard(require("../constants/silencedErrors")),
    _genericError = require("../constants/genericError");

function getErrorCode(a) {
  return (0, _lodash["default"])(a, "extensions.code") || (0, _lodash["default"])(a, "graphQLErrors[0].extensions.code") || (0, _lodash["default"])(a, "networkError.result.errors[0].extensions.code");
}

function getException(a) {
  return (0, _lodash["default"])(a, "extensions.exception") || (0, _lodash["default"])(a, "graphQLErrors[0].extensions.exception");
}

function isSilencedError(a) {
  var b = getErrorCode(a);
  return b && _silencedErrors["default"][b];
}

function makeRequest() {
  return _makeRequest.apply(this, arguments);
}

function _makeRequest() {
  return _makeRequest = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b, c, d) {
    var e, f, g, h, i, j;
    return _regenerator["default"].wrap(function (a) {
      for (;;) {
        switch (a.prev = a.next) {
          case 0:
            return a.prev = 0, a.next = 3, b(c);

          case 3:
            return e = a.sent, f = e.data, g = e.errors, h = g && g.length, h && !isSilencedError(g[0]) && (0, _Notifications.notify)({
              type: "error",
              content: _genericError.GENERIC_ERROR_MSG
            }), h && getErrorCode(g[0]) === _silencedErrors.FORBIDDEN && (i = getException(g[0]), d({
              resourceOwnerId: i.ownerId
            })), a.abrupt("return", {
              data: f,
              error: h ? _genericError.GENERIC_ERROR_MSG : void 0
            });

          case 12:
            return a.prev = 12, a.t0 = a["catch"](0), isSilencedError(a.t0) || (0, _Notifications.notify)({
              type: "error",
              content: _genericError.GENERIC_ERROR_MSG
            }), getErrorCode(a.t0) === _silencedErrors.FORBIDDEN && (j = getException(a.t0), d({
              resourceOwnerId: j.ownerId
            })), a.abrupt("return", {
              error: _genericError.GENERIC_ERROR_MSG
            });

          case 17:
          case "end":
            return a.stop();
        }
      }
    }, a, null, [[0, 12]]);
  })), _makeRequest.apply(this, arguments);
}

var _default = makeRequest;
exports["default"] = _default;